// src/utils.js
export function capitalize(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function limitText(value, maxLength = 100) {
  if (!value) return '';
  value = value.toString();
  return value.length > maxLength ? value.slice(0, maxLength) + '...' : value;
}